/**
 *  
 * @description takes values and acts as the function that executes when form is submitted
 */

import { updateOrg, xflowPurposeCodeUpdate } from "../../../services/httpCalls"
import { cleanObject } from "../clean-object";



export const handleCkycFinish = async ({
    values,
    isGstNotThere,
    dateFormat,
    isOptInward,
    isEditActive,
    addressThere,
    flagAddress,
    sameAddress,
    updateAddress,
    addressIds,
    addAddress,
    Cookies,
    notify,
    handleChange,
    setShowLoader,
    selectionValue,
    form,
    partnerState, 
    companyTypeState,
    website,
    socialWebsite,
    merchantProductType,
    isOptOutward,
    isXflowActive
}) => {

  const getXflowPurposeCodeObject = (data) => {
    let xflowPurposeCode = []
        data?.map((item) => {
          xflowPurposeCode.push({
            code: item,
          })
        })
  
        return xflowPurposeCode;
  }
    if(form.getFieldValue('productDescription')){
      values = {
        ...values,
        productDescription: values?.productDescription?.replace(/(\r\n|\n|\r)/gm, " ")
      }
    }
    if(merchantProductType === "PHYSICAL"){
      if(!form.getFieldValue('importExportCode')){
        form.setFields([
          {
            name:'importExportCode',
            errors:['Required!']
          }
        ])
        return;
      }
    }

    if(Boolean(partnerState.length) && (['SOLE_PRORIETOR','FREELANCER'].includes(companyTypeState) && partnerState.includes('payglocal'))){
      if(!form.getFieldValue('socialWebsite') || !form.getFieldValue('website')){
        if(!form.getFieldValue('socialWebsite')){
          form.setFields([
            {
              name:'socialWebsite',
              errors:['Required!']
            }
          ])
          return;
        }
        if(!form.getFieldValue('website')){
          form.setFields([
            {
              name:'website',
              errors:['Required!']
            }
          ])
          return;
        }
      }
    } else {
      if((!website.length || (!website.length && !socialWebsite.length))){
        if(!form.getFieldValue('socialWebsite')) {
          form.setFields([
            {
              name:'socialWebsite',
              errors:['Required!']
            }
          ])
          return;
        }
      }
      if((!socialWebsite || (!website.length && !socialWebsite.length))){
        if(!form.getFieldValue('website')) {
          form.setFields([
            {
              name:'website',
              errors:['Required!']
            }
          ])
          return;
        }
      }
    }

    let getTransactionType = () => {
        switch(selectionValue) {
        case 'inward' : return "RECEIVE_MONEY";
        case 'outward': return "SEND_MONEY";
        case 'both': return "SEND_AND_RECEIVE_MONEY";
        default: return null
       }
    }
    let data = {
      panNumber: values?.panNumber?.toUpperCase(),
      name: values?.legalName,
      gstNumber: isGstNotThere ? "" : values?.gstNumber,
      cinNumber: values.cin,
      leiNumber: values.leiNumber,
      dateOfIncorporation: values.dateOfIncorporation?.format(
        dateFormat
      ),
      countryOfIncorporation: values.countryOfIncorporation,
      placeOfIncorporation: values.placeOfIncorporation,
      natureOfBusiness: values.natureOfBussiness,
      annualTurnover: Number(values.annualTurnover),
      companyType: values.companyType,
      importExportCode: values.importExportCode,
      tanNumber: values.tan,
      status: "DRAFT_CORPORATE_DOCS",
      orgEmail: values.comapnyEmail,
      doingBusinessAs: values?.doingBusinessAs,
      descriptionForOutward: values?.descriptionForOutward,
      descriptionForInward: values?.descriptionForInward,
      transactionType: getTransactionType(),
      socialWebsite: values?.socialWebsite,
      website: values?.website,
      // payglocal fields
      hsnNumber: values.hsnNumber,
      monthlyPaymentVolume: values.monthlyPaymentVolume,
      howCustomerInteractWithBusiness: values.howCustomerInteractWithBusiness,
      productDescription: values.productDescription,
      doingBusinessAs: values.doingBusinessAs,
      merchantProductType: values.merchantProductType,
      phoneNumber: values.phoneNumber,
      averageTicketSize: values.averageTicketSize,
      purposeCode: values.purposeCode,
      additionalUrl: values?.additionalUrl
    }
    if (isEditActive) {
      delete data.status
    }
    data.xflowPurposeCodeList = getXflowPurposeCodeObject(form.getFieldValue('xflowPurposeCode'))
    let cleanData = cleanObject(data);
    let orgId = localStorage.getItem("orgId")
    return updateOrg(cleanData, orgId)
      .then(async res => {
        if(!res?.errors) {
        if (res) {
          // updating xflow purpose code 
          if(form.getFieldValue('xflowPurposeCode')?.length){
            if(isXflowActive){
            let orgId = localStorage.getItem("orgId");
            let purposeCode = getXflowPurposeCodeObject(form.getFieldValue('xflowPurposeCode'))
            xflowPurposeCodeUpdate(purposeCode, orgId)
              .then((res) => {
                if (res) {
                  notify.success("Xflow purpose code updated !")
                }
              })
              .catch((err) => {
                if (err) {
                  return err;
                }
              })
            }
          }

          let addressData
          if (addressThere) {
            if (flagAddress || partnerState.includes('payglocal')) {
              if (sameAddress) {
                addressData = {
                  addressLineOne: values.registeredAddress_addressLineOne,
                  addressLineTwo: values.registeredAddress_addressLineTwo,
                  city: values.registeredAddress_city,
                  country: values.registeredAddress_country,
                  pinCode: values.registeredAddress_pinCode.toString(),
                  state: values.registeredAddress_state,
                  type: "REGISTERED"
                }
                let cleanAddressData = cleanObject(addressData)
                updateAddress(cleanAddressData, orgId, addressIds.REGISTERED)
                cleanAddressData.type = "BUSINESS"
                if(addressIds.BUSINESS){
                  updateAddress(cleanAddressData, orgId, addressIds.BUSINESS)
                }else{
                  addAddress(cleanAddressData, orgId)
                }
              } else {
                addressData = {
                  addressLineOne: values.registeredAddress_addressLineOne,
                  addressLineTwo: values.registeredAddress_addressLineTwo,
                  city: values.registeredAddress_city,
                  country: values.registeredAddress_country,
                  pinCode: values.registeredAddress_pinCode.toString(),
                  state: values.registeredAddress_state,
                  type: "REGISTERED"
                }
                let cleanAddressData = cleanObject(addressData)
                updateAddress(cleanAddressData, orgId, addressIds.REGISTERED)
                if (isOptOutward || partnerState.includes('payglocal')) {
                  addressData = {
                    addressLineOne: values.bussinessAddress_addressLineOne,
                    addressLineTwo: values.bussinessAddress_addressLineTwo,
                    city: values.bussinessAddress_city,
                    country: values.bussinessAddress_country,
                    pinCode: values.bussinessAddress_pinCode.toString(),
                    state: values.bussinessAddress_state,
                    type: "BUSINESS"
                  }
                  let cleanAddressData = cleanObject(addressData)
                  if(addressIds.BUSINESS){
                    updateAddress(cleanAddressData, orgId, addressIds.BUSINESS)
                  }else{
                    addAddress(cleanAddressData, orgId)
                  }
                }
              }
            }
          } else {
            if (sameAddress) {
              addressData = {
                addressLineOne: values.registeredAddress_addressLineOne,
                addressLineTwo: values.registeredAddress_addressLineTwo,
                city: values.registeredAddress_city,
                country: values.registeredAddress_country,
                pinCode: values.registeredAddress_pinCode.toString(),
                state: values.registeredAddress_state,
                type: "REGISTERED"
              }
              let cleanAddressData = cleanObject(addressData)
              addAddress(cleanAddressData, orgId)
              cleanAddressData.type = "BUSINESS"
              if(addressIds.BUSINESS){
                updateAddress(cleanAddressData, orgId, addressIds.BUSINESS)
              }else{
                addAddress(cleanAddressData, orgId)
              }
            } else {
              addressData = {
                addressLineOne: values.registeredAddress_addressLineOne,
                addressLineTwo: values.registeredAddress_addressLineTwo,
                city: values.registeredAddress_city,
                country: values.registeredAddress_country,
                pinCode: values.registeredAddress_pinCode.toString(),
                state: values.registeredAddress_state,
                type: "REGISTERED"
              }
              let cleanAddressData = cleanObject(addressData)
              addAddress(cleanAddressData, orgId)
              if (isOptOutward || partnerState.includes('payglocal')) {
                addressData = {
                  addressLineOne: values.bussinessAddress_addressLineOne,
                  addressLineTwo: values.bussinessAddress_addressLineTwo,
                  city: values.bussinessAddress_city,
                  country: values.bussinessAddress_country,
                  pinCode: values.bussinessAddress_pinCode.toString(),
                  state: values.bussinessAddress_state,
                  type: "BUSINESS"
                }
                let cleanAddressData = cleanObject(addressData)
                addAddress(cleanAddressData, orgId)
              }
            }
          }
        }
      } else {
        notify.error(res.errors)
      }
      })
      .finally(async () => {
        setShowLoader(false)
        Cookies.set("currentStage", "3")
        notify.success("CKYC submitted!")
        handleChange(3)
      })
  }
